<mat-icon
    class="santander-icon"
    svgIcon="santander-bank"
  ></mat-icon>
<span class="title">
  <ng-content></ng-content>
</span>
